import http from "../../../utils/http";

const { createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchUsers = createAsyncThunk("/user/details", async () => {
  const { data } = await http.get("/api/user/All");
  return data;
});

export const fetchVendors = createAsyncThunk("/vendor/details", async () => {
  const { data } = await http.get("/api/admin/getVendors");
  return data;
});

export const fetchPointsAdded = createAsyncThunk(
  "/user/addedPoints",
  async () => {
    const { data } = await http.get("/api/admin/addedPoints");
    return data;
  }
);

export const fetchCreditsAdded = createAsyncThunk(
  "/user/addedCredits",
  async () => {
    const { data } = await http.get("/api/admin/addedCredits");
    return data;
  }
);

export const fetchPointsTransfered = createAsyncThunk(
  "/user/transferPoints",
  async () => {
    const { data } = await http.get("/api/admin/transferPoints");
    return data;
  }
);

export const fetchPointsRedeemed = createAsyncThunk(
  "/user/RedeemedPoints",
  async () => {
    const { data } = await http.get("/api/admin/redeemPoints");
    return data;
  }
);
export const fetchVendorTransaction = createAsyncThunk(
  "/vendor/TransactionHistory",
  async () => {
    const { data } = await http.get("/api/vendor/redeemPoints");
    return data;
  }
);

export const fetchSearchedUser = createAsyncThunk(
  "/user/searched",
  async (cardNo) => {
    try {
      const { data } = await http.get(`/api/admin/searchUser/${cardNo}`);
      return data;
    } catch (err) {
      const error = err.response.data;
      return error;
    }
  }
);

export const updateTransactionStatus = createAsyncThunk(
  "/admin/updateTransactionStatus",
  async ({ transactionId, status }) => {
    try {
      const { data } = await http.post("/api/admin/updateTransactionStatus", {
        transactionId,
        status,
      });
      return data;
    } catch (err) {
      const error = err.response.data;
      return error;
    }
  }
);

export const generatePaymentReport = createAsyncThunk(
  "/admin/generatePaymentReport",
  async ({ startDate, endDate, vendorId }) => {
    try {
      const payload = { startDate, endDate };
      if (vendorId) {
        payload.vendorId = vendorId;
      }
      
      const { data } = await http.post("/api/admin/generatePaymentReport", payload);
      return data;
    } catch (err) {
      const error = err.response.data;
      return error;
    }
  }
);

export const getFilteredAddedPoints = createAsyncThunk(
  "/admin/getFilteredAddedPoints",
  async ({ startDate, endDate, pointsType, vendor, category }) => {
    try {
      const payload = { startDate, endDate, pointsType };
      if (vendor) payload.vendor = vendor;
      if (category) payload.category = category;
      
      const { data } = await http.post("/api/admin/getFilteredAddedPoints", payload);
      return data;
    } catch (err) {
      const error = err.response?.data || { success: false, message: "Network error" };
      return error;
    }
  }
);
